import * as React from "react";


const PageSession = () => {
    return (
        <div style={{margin: 30}}>
            <div className="alert alert-info">
                <h1 className="error-header"><span
                    className="icon icon-md dls-icon-warning dls-gray-05"/>&nbsp;Invitation Expired !!</h1>
                <p>Your session has expired for the current invitation. Please contact CTP product team to get a new
                    invite.</p>
            </div>
        </div>
    );
};

export default PageSession;
